export enum FiltersActionTypes {
  ApplyFilters = '[Filters] Apply Filters',
  ApplyExtendedFilters = '[Filters] Apply Extended Filters',
  SetSettings = '[Filters] Set Settings',
  ResetFilters = '[Filters] Reset Filters',
}
